export default "__VITE_ASSET__CFiZnLm6__"